import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';

import {
    Input,
    TextArea,
    DatePicker,
    Form,
    Switch,
    Button
} from '@gpstrackit/gtc-react-controls';

const DateTime = (props) => {
    const { messages } = useIntl();
    const questionForm = Form.useForm();

    const {
        question,
        handleClose,
        updateQuestion
    } = props;

    const open = useSelector(state => state.dynamicFormsDesignRedux.openQuestionConfiguration);
    const loading = useSelector(state => state.dynamicFormsDesignRedux.loading);

    const [formData, setFormData] = useState({});
    const [ minDate, setMinDate ] = useState();

    useEffect(() => {
        if (open && questionForm?.ref && question) {
            questionForm?.setValues({
                ...question,
                default: question?.attributes?.default,
                minimum: question?.attributes?.minimum,
                maximum: question?.attributes?.maximum,
            });
        }
    }, [questionForm?.ref, open, question]);

    return (
        <div>
            <Form
                ref={questionForm?.ref}
                loading={loading}
                onValidSubmit={(values) => {
                    let newQuestion = {
                        ...question,
                        label: values?.label,
                        placeHolder: values?.placeHolder,
                        help: values?.help,
                        required: values?.required,
                        readOnly: values?.readOnly,
                        attributes: {
                            default: values?.default,
                            minimum: values?.minimum,
                            maximum: values?.maximum,
                        }
                    }

                    updateQuestion(newQuestion);
                }}
                onChangeValues={(values) => {
                    setFormData(values);
                    if (values?.minimum) {
                        setMinDate(values?.minimum);
                    }
                }}
            >
                <div>
                    <Form.Item
                        name="label"
                        label={messages['dynamicFormsDesign_label']}
                        rules={[{ required: true, message: 'required_field' }]}
                    >
                        <Input
                            id="label"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_label']}
                            maxLength={100}
                        />
                    </Form.Item>

                    <Form.Item 
                        name="placeHolder" 
                        label={messages['dynamicFormsDesign_placeholder']} 
                    >
                        <Input
                            id="placeHolder"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_placeholder']}
                            maxLength={100}
                        />
                    </Form.Item>

                    <Form.Item
                        name="help"
                        label={messages['dynamicFormsDesign_helpText']}
                    >
                        <TextArea
                            id="help"
                            placeholder={messages['dynamicFormsDesign_helpText']}
                            maxLength={1000}
                        />
                    </Form.Item>

                    <Form.Item
                        name="required"
                        label={messages['dynamicFormsDesign_required']}
                    >
                        <Switch
                            id="required"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        readOnly: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="readOnly"
                        label={messages['dynamicFormsDesign_readOnly']}
                    >
                        <Switch
                            id="readOnly"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        required: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="default"
                        label={messages['dynamicFormsDesign_defaultDate']}
                    >
                        <DatePicker
                            id="default"
                            placeholder={messages['dynamicFormsDesign_defaultDate']}
                            showTimePicker
                        />
                    </Form.Item>

                    <Form.Item
                        name="minimum"
                        label={messages['dynamicFormsDesign_minimumDate']}
                    >
                        <DatePicker
                            id="minimum"
                            placeholder={messages['dynamicFormsDesign_minimumDate']}
                            showTimePicker
                        />
                    </Form.Item>

                    <Form.Item
                        name="maximum"
                        label={messages['dynamicFormsDesign_maximumDate']}
                        rules={[
                            { minDate: minDate || null, message: `${messages['dynamicFormsDesign_minDateTimeValue']}: ${minDate ? moment(minDate).format("MMMM D YYYY, hh:mm a") : null}` }
                        ]}
                    >
                        <DatePicker
                            id="maximum"
                            placeholder={messages['dynamicFormsDesign_maximumDate']}
                            minDate={minDate || null}
                            showTimePicker
                        />
                    </Form.Item>
                </div>
            </Form>

            <div style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                    style={{ marginRight: 8 }}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.resetValues()
                        handleClose();
                    }}
                    variant='secondary'
                >
                    {messages['cancel']}
                </Button>

                <Button
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.submit();
                    }}
                    variant='primary'
                >
                    {messages['save']}
                </Button>
            </div>
        </div>
    );
}

export default DateTime;